/**
 * Cyphon Cart Drawer Interactions & Enhancements
 * Pure event delegation - 0 MutationObserver, 0 CPU overhead, bulletproof performance
 */

(function () {
  // --- 1. Synchronize Chip Active States with Current Note Text ---
  function syncChipStatesWithText() {
    const noteTextarea = document.querySelector('.bls__cart-note');
    if (!noteTextarea) return;

    const currentVal = noteTextarea.value.trim().toLowerCase();
    const parts = noteTextarea.value.split(',').map(function (s) {
      return s.trim().toLowerCase();
    }).filter(Boolean);

    document.querySelectorAll('.cy-instruction-chip').forEach(function (chip) {
      const chipText = (chip.getAttribute('data-chip') || chip.textContent).trim().toLowerCase();
      if (!chipText) return;
      const isActive = parts.includes(chipText) || currentVal.includes(chipText);
      if (isActive) {
        chip.classList.add('active');
      } else {
        chip.classList.remove('active');
      }
    });

    const charCounter = document.getElementById('cy-char-current');
    if (charCounter) {
      charCounter.textContent = noteTextarea.value.length;
    }
  }

  // --- 2. Toggle Chip On / Off (Untick Support) ---
  function toggleChip(chip) {
    const chipText = (chip.getAttribute('data-chip') || chip.textContent).trim();
    const noteTextarea = document.querySelector('.bls__cart-note');
    if (!noteTextarea || !chipText) return;

    let parts = noteTextarea.value.split(',').map(function (s) {
      return s.trim();
    }).filter(Boolean);

    const lowerChip = chipText.toLowerCase();
    const existingIndex = parts.findIndex(function (p) {
      return p.toLowerCase() === lowerChip;
    });

    if (existingIndex > -1 || chip.classList.contains('active')) {
      // Untick / Remove chip
      if (existingIndex > -1) {
        parts.splice(existingIndex, 1);
        noteTextarea.value = parts.join(', ');
      } else {
        const escaped = chipText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp('(?:,\\s*)?' + escaped + '|(?:' + escaped + '\\s*,?\\s*)', 'gi');
        noteTextarea.value = noteTextarea.value.replace(regex, '').trim().replace(/^,\s*|,\s*$/g, '');
      }
      chip.classList.remove('active');
    } else {
      // Tick / Add chip
      parts.push(chipText);
      noteTextarea.value = parts.join(', ');
      chip.classList.add('active');
    }

    syncChipStatesWithText();

    // Trigger input & change events for theme listeners
    noteTextarea.dispatchEvent(new Event('input', { bubbles: true }));
    noteTextarea.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // --- 3. Live Input Sync ---
  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList.contains('bls__cart-note')) {
      syncChipStatesWithText();
    }
  });

  // --- 4. Event Delegation for All Cart Interactions ---
  document.addEventListener('click', function (e) {
    // A. Quick Instruction Chips (Toggle on / Toggle off / Untick)
    const chip = e.target.closest('.cy-instruction-chip');
    if (chip) {
      e.preventDefault();
      toggleChip(chip);
      return;
    }

    // B. Opening Note Drawer -> Sync chip states immediately
    const openNote = e.target.closest('button[data-open="note"]');
    if (openNote) {
      setTimeout(syncChipStatesWithText, 50);
    }

    // C. "Check Delivery" Button -> Validate PIN input before calculating rates
    const checkDeliveryBtn = e.target.closest('.cy-btn-check-delivery');
    if (checkDeliveryBtn) {
      const zipInput = document.getElementById('AddressZip');
      if (zipInput && !zipInput.value.trim()) {
        e.preventDefault();
        zipInput.focus();
        zipInput.style.borderColor = '#ef4444';
        const originalPlaceholder = zipInput.placeholder;
        zipInput.placeholder = 'Please enter PIN code';
        setTimeout(function () {
          zipInput.style.borderColor = '';
          zipInput.placeholder = originalPlaceholder || 'e.g. 380015';
        }, 2200);
        return;
      }
      // If PIN is entered, proceed so theme shipping rate calculation fires
    }

    // D. Sub-drawer Back Buttons & Close [✕] Buttons -> Return to Cart Drawer Slider
    const closeOrBackBtn = e.target.closest('.cy-addon-back-btn, .cy-addon-close-btn, .cy-btn-cancel-note');
    if (closeOrBackBtn) {
      e.preventDefault();
      e.stopPropagation();
      document.querySelectorAll('.bls__addon.is-open').forEach(function (addon) {
        addon.classList.remove('is-open');
      });
      document.querySelectorAll('.bls-minicart-wrapper').forEach(function (wrapper) {
        wrapper.classList.remove('addons-open');
      });
      return;
    }
  });

  // Initial sync on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncChipStatesWithText);
  } else {
    syncChipStatesWithText();
  }
})();
